<ng-container *ngIf="{ isDark: (theme.isDark$ | async) ?? false } as vm">
  <ng-container *ngIf="linkTo; else plainLockup">
    <app-a
      [class]="anchorCssClass"
      [routeTo]="linkTo"
      [bold]="false"
      [tid]="tid"
      ink="primary-action"
    >
      <div class="unity-brand-lockup__row">
        <img
          class="unity-brand-lockup__logo"
          [src]="vm.isDark ? logoWhiteSrc : logoColorSrc"
          alt="Unity logo"
          width="29"
          height="40"
        />
        <app-body-lg [ink]="vm.isDark ? 'ink-white' : 'primary-action'">Unity</app-body-lg>
      </div>
    </app-a>
  </ng-container>
  <ng-template #plainLockup>
    <div class="unity-brand-lockup__row" aria-label="Unity">
      <img
        class="unity-brand-lockup__logo"
        [src]="vm.isDark ? logoWhiteSrc : logoColorSrc"
        alt="Unity logo"
        width="29"
        height="40"
      />
      <app-body-lg [ink]="vm.isDark ? 'ink-white' : 'primary-action'">Unity</app-body-lg>
    </div>
  </ng-template>
</ng-container>
